// Getters do módulo Gestão Fee Fixo. Sempre retornam valor default
// (array/objeto), nunca undefined.

// --- Dashboard ---
export const dashboard = (state) => state.dashboard.data || {}
export const dashboardLoading = (state) => state.dashboard.loading
export const dashboardLastUpdate = (state) => state.dashboard.lastUpdate

// --- Clientes (por visão) ---
export const clientesProfissional = (state) =>
  state.clientesProfissional.data || []
export const clientesProfissionalLoading = (state) =>
  state.clientesProfissional.loading
export const clientesProfissionalLastUpdate = (state) =>
  state.clientesProfissional.lastUpdate

export const clientesEscritorio = (state) => state.clientesEscritorio.data || []
export const clientesEscritorioLoading = (state) =>
  state.clientesEscritorio.loading
export const clientesEscritorioLastUpdate = (state) =>
  state.clientesEscritorio.lastUpdate

export const clientesVisao = (state) => state.clientesVisao || 'profissional'

// Slice ativo conforme a visão do toggle — conveniência para o seletor.
const sliceClientes = (state, visao) =>
  visao === 'escritorio' ? state.clientesEscritorio : state.clientesProfissional
export const clientesAtivos = (state) =>
  sliceClientes(state, state.clientesVisao).data || []
export const clientesAtivosLoading = (state) =>
  sliceClientes(state, state.clientesVisao).loading

// --- Simulação (histórico de análises) ---
export const analises = (state) => state.analises.data || []
export const analisesLoading = (state) => state.analises.loading
export const analisesLastUpdate = (state) => state.analises.lastUpdate

// --- Cliente ativo do módulo (Simulação e Ensaio) ---
export const clienteAtivoCodigo = (state) =>
  (state.clienteAtivo && state.clienteAtivo.codigo) || null
export const clienteAtivoNome = (state) =>
  (state.clienteAtivo && state.clienteAtivo.nome) || ''
export const clienteAtivoDetalhe = (state) =>
  (state.clienteAtivo && state.clienteAtivo.detalhe) || null
